import React from "react";
import dateFns from "date-fns";
import es from "date-fns/locale/es";

interface CalendarDaysNamesProps {
  newDate: Date;
}

const CalendarDaysNames = ({ newDate }: CalendarDaysNamesProps) => {
  const getDaysNames = () => {
    const dateFormat = "dd";
    const days = [];
    const startDate = dateFns.startOfWeek(newDate, {
      weekStartsOn: 1,
    });
    for (let i = 0; i < 7; i++) {
      days.push(
        <div className="calendar-days-day" key={i}>
          <div>
            <p>
              {dateFns.format(dateFns.addDays(startDate, i), dateFormat, {
                locale: es,
              })}
            </p>
          </div>
        </div>
      );
    }
    return days;
  };

  return <div className="calendar-days">{getDaysNames()}</div>;
};

export default CalendarDaysNames;
